export default function(api: GlobalFetch) {
  return async function(value, calendarId) {
    const requestBody = {
      pricelist_multi: value? 1: 0,
      id_calendar: calendarId,
    }
    const response = await api.fetch(
      `/api/v2/pricemulti/toogle/`,
      {
        body: JSON.stringify(requestBody),
        method: 'POST',
      },
    )

    if (response.ok) {
      return  response.status
    } else {
      throw new Error(response.status.toString())
    }
  }
}
